import {
  Button,
  Card,
  Col,
  Form,
  Drawer,
  notification,
  Row
} from 'antd'
import moment from 'moment'
import React, { useEffect, useState } from 'react'

import { connect, useDispatch } from 'react-redux'
import GetEachFormFields from '../../../components/_utils/appFormUtils'
import { getUrlParams } from '../../../routes'
import { paymentModeList } from '../../../components/_utils/appUtils'
import { updateInvoiceStatusFxn } from '../action'

const AddPaymentDrawer = (props) => {
  let { form, visible, onClose, totalAmount, _id, invoiceId, reloadData } = props
  let { setFieldsValue, getFieldValue, getFieldDecorator } = form
  let [discountAmount, setDiscountAmount] = useState(0)
  let dispatch = useDispatch()

  useEffect(() => {
    setFormData()
  }, [totalAmount])
  const setFormData = async () => {
    setTimeout(() => {
      form.setFieldsValue({
        amount: totalAmount
      })
    }, 100)
  }

  const handleSubmit = e => {
    let urlObj = getUrlParams('singleGeneralSubscription', window.location.pathname)
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        const subscriptionId = urlObj.id
        valData.generalSubscriptionId = subscriptionId
        if (!valData.paymentDetails || !Array.isArray(valData.paymentDetails)) {
          valData.paymentDetails = []
        }

        const paymentInfo = {
          amount: valData.amount,
          modeOfPayment: valData.modeOfPayment,
          receivedDate: valData.receivedDate || new Date(),
          invoiceId: invoiceId, // Link payment to invoice
          transactionId: valData.transactionId,
          discountAmount: discountAmount,
          discount: valData.discount,
          netAmount: valData.netAmount
        }
        // valData.generalSubscriptionId = _id
        valData.invoiceId = invoiceId
        valData.receivedDate = moment(valData.receivedDate).toISOString()
        valData.paymentDetails = paymentInfo
        let { success, message, data } = await dispatch(updateInvoiceStatusFxn(valData))
        if (success) {
          notification.success({
            message: message
          })
          reloadData()
          setDiscountAmount(0)
          onClose()
        }
      }
    })

  }

  const calculateNetAmount = () => {
    let amount = getFieldValue('amount')
    let discount = getFieldValue('discount')
    let discountAmount = ((amount * discount) / 100) || 0
    let netAmount = (amount - discountAmount) || amount
    setDiscountAmount(discountAmount)
    setFieldsValue({
      netAmount, discountAmount
    })
  }

  useEffect(() => {
    calculateNetAmount()
  }, [getFieldValue('amount'), getFieldValue('discount')])


  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 }
    }
  }

  const inputSchma = {
    paymentFields: [
      {
        label: 'Received Date',
        key: 'receivedDate',
        required: true,
        placeholder: 'Received Date',
        type: 'date'
      },
      {
        label: 'Mode Of Payment',
        key: 'modeOfPayment',
        required: true,
        placeholder: 'Mode Of Payment',
        type: 'select',
        options: paymentModeList,
        allowClear: true,
        keyAccessor: x => x,
        valueAccessor: x => x,
        onChange: (val) => {
          setFieldsValue({ modeOfPayment: val })
        }
      },
      {
        label: 'Transaction/Cheque ID',
        key: 'transactionId',
        required: false,
        placeholder: 'Enter Transaction/Cheque ID'
      }
    ],
    amountFields: [
      {
        label: 'Amount',
        key: 'amount',
        required: true,
        placeholder: 'Amount'
      },
      {
        label: 'Discount (In Percentage)',
        key: 'discount',
        placeholder: 'Discount'
      },
      {
        label: 'Net Amount',
        key: 'netAmount',
        required: true,
        placeholder: 'Net Amount',
        disabled: true
      }
    ]
  }
  return (
    <Drawer
      title={'Add Payment Details'}
      width={'45%'}
      visible={visible}
      maskClosable={true}
      placement='right'
      onClose={onClose}>
      <Card bordered={true}>
        <Form
          onSubmit={handleSubmit}
          hideRequiredMark
          noValidate={true}
          className={'inputForm'}>
          <Card bordered={true} size={'small'}>
            <Row gutter={16}>
              {inputSchma.paymentFields.map((item, key) => {
                return (
                  <Col span={item.span ? item.span : 12}
                       md={item.span ? item.span : 12}
                       sm={12}
                       xs={24}
                       key={key}>
                    <GetEachFormFields
                      item={item}
                      getFieldDecorator={getFieldDecorator}
                      formItemLayout={formItemLayout}
                    />
                  </Col>
                )
              })}
            </Row>
            <hr className={'hr-color'} />
            <Row gutter={16} className={'mt10'}>
              {inputSchma.amountFields.map((item, key) => {
                return (
                  <Col span={8}
                       md={8}
                       sm={12}
                       xs={24}
                       key={key}>
                    <GetEachFormFields
                      item={item}
                      getFieldDecorator={getFieldDecorator}
                      formItemLayout={formItemLayout}
                    />
                  </Col>
                )
              })}
            </Row>
          </Card>


          <Form.Item style={{ marginTop: 10 }}>
            <Button type='primary' htmlType='submit'>
              SUBMIT
            </Button>
          </Form.Item>
        </Form>


      </Card>
    </Drawer>
  )
}

const WrappedAddPaymentDrawer = Form.create()(AddPaymentDrawer)
export default WrappedAddPaymentDrawer
